function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.177 1.059l-9.06 10.705L1 7.942",
  stroke: "#6D8092",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgCheckmarkGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    fill: "none"
  }, props), _ref);
}
export default SvgCheckmarkGray;